var map = {
	"./SpinGeneral__001.webp": 3957,
	"./SpinGeneral__002.webp": 1645,
	"./SpinGeneral__003.webp": 6545,
	"./SpinGeneral__004.webp": 422,
	"./SpinGeneral__005.webp": 6091,
	"./SpinGeneral__006.webp": 5818,
	"./SpinGeneral__007.webp": 2956,
	"./SpinGeneral__008.webp": 9719,
	"./SpinGeneral__009.webp": 8012,
	"./SpinGeneral__010.webp": 4616,
	"./SpinGeneral__011.webp": 8609,
	"./SpinGeneral__012.webp": 3409,
	"./SpinGeneral__013.webp": 5487,
	"./SpinGeneral__014.webp": 6779,
	"./SpinGeneral__015.webp": 3278,
	"./SpinGeneral__016.webp": 7513,
	"./SpinGeneral__017.webp": 6472,
	"./SpinGeneral__018.webp": 5156,
	"./SpinGeneral__019.webp": 259,
	"./SpinGeneral__020.webp": 9771,
	"./SpinGeneral__021.webp": 922,
	"./SpinGeneral__022.webp": 5655,
	"./SpinGeneral__023.webp": 6233,
	"./SpinGeneral__024.webp": 5247,
	"./SpinGeneral__025.webp": 5243,
	"./SpinGeneral__026.webp": 3344,
	"./SpinGeneral__027.webp": 3544,
	"./SpinGeneral__028.webp": 5376,
	"./SpinGeneral__029.webp": 6321,
	"./SpinGeneral__030.webp": 2788,
	"./SpinGeneral__031.webp": 4838,
	"./SpinGeneral__032.webp": 9764,
	"./SpinGeneral__033.webp": 1179,
	"./SpinGeneral__034.webp": 1596,
	"./SpinGeneral__035.webp": 77,
	"./SpinGeneral__036.webp": 7222,
	"./SpinGeneral__037.webp": 6040,
	"./SpinGeneral__038.webp": 368,
	"./SpinGeneral__039.webp": 4126,
	"./SpinGeneral__040.webp": 5916,
	"./SpinGeneral__041.webp": 7480,
	"./SpinGeneral__042.webp": 4435,
	"./SpinGeneral__043.webp": 4474,
	"./SpinGeneral__044.webp": 2420,
	"./SpinGeneral__045.webp": 9654,
	"./SpinGeneral__046.webp": 8027,
	"./SpinGeneral__047.webp": 1374,
	"./SpinGeneral__048.webp": 4379,
	"./SpinGeneral__049.webp": 9074,
	"./SpinGeneral__050.webp": 9421,
	"./SpinGeneral__051.webp": 3475,
	"./SpinGeneral__052.webp": 6887,
	"./SpinGeneral__053.webp": 4560,
	"./SpinGeneral__054.webp": 3588,
	"./SpinGeneral__055.webp": 2909,
	"./SpinGeneral__056.webp": 3345,
	"./SpinGeneral__057.webp": 2661,
	"./SpinGeneral__058.webp": 8136,
	"./SpinGeneral__059.webp": 587,
	"./SpinGeneral__060.webp": 5661,
	"./SpinGeneral__061.webp": 2709,
	"./SpinGeneral__062.webp": 2998,
	"./SpinGeneral__063.webp": 675,
	"./SpinGeneral__064.webp": 6074,
	"./SpinGeneral__065.webp": 5739,
	"./SpinGeneral__066.webp": 4670,
	"./SpinGeneral__067.webp": 2740,
	"./SpinGeneral__068.webp": 3390,
	"./SpinGeneral__069.webp": 9932,
	"./SpinGeneral__070.webp": 1062,
	"./SpinGeneral__071.webp": 5070,
	"./SpinGeneral__072.webp": 3263
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6132;